import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Input, Typography, message } from "antd";
import api from "../api/axiosClient";

const { Title } = Typography;

// Format units nicely
const formatUnits = (val) => {
  if (!val) return "";
  return val
    .replace(/(\d+)([a-zA-Z]+)/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
};

export default function MeasurementTopicsQuiz({
  category,
  level,
  selectedLevel,
  user,
  addPointsToBackend,
  topics,
}) {
  const [questions, setQuestions] = useState([]);
  const [index, setIndex] = useState(0);
  const [answer, setAnswer] = useState("");
  const [userAnswers, setUserAnswers] = useState([]);
  const [finished, setFinished] = useState(false);
  const [results, setResults] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
const [submitting, setSubmitting] = useState(false);
  const [aiExplanations, setAiExplanations] = useState({});
  const [loadingExplanation, setLoadingExplanation] = useState(false);

  const inputRef = useRef(null);

  // -----------------------------
  // API Endpoints
  // -----------------------------

  const endpoints = {
    conversion: {
      get: "quiz/measurement",
      check:"quiz/checkmeasurement"
    },
    addsub: {
      get: "quiz/measurement2",
      check:"quiz/checkmeasurement"
    },
    wordproblems: {
     get: "quiz/measurement3",
      check:"quiz/checkmeasurement"
    },
  };

  const currentEndpoint =
    endpoints[topics] || endpoints.conversion;

  // -----------------------------
  // Load Questions
  // -----------------------------

  const fetchQuestions = async () => {
    try {
      setLoading(true);
 setSubmitting(false); 
      setSubmitted(false);
      setFinished(false);
      setResults([]);
      setAnswer("");
      setIndex(0);
      setUserAnswers([]);
      setAiExplanations({});

      const res = await api.get(currentEndpoint.get);

      setQuestions(res.data.questions);
    } catch (err) {
      message.error("Failed to load quiz");
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchQuestions();
  }, [topics]);

  useEffect(() => {
    inputRef.current?.focus();
  }, [index]);

  // useEffect(() => {
  //   if (
  //     questions.length > 0 &&
  //     index === questions.length &&
  //     !finished
  //   ) {
  //     setFinished(true);
  //     finishQuiz();
  //   }
  // }, [index, questions.length, finished]);



const finishQuiz = async (answers = userAnswers) => {
    setSubmitted(true);

    try {
      const res = await api.post(currentEndpoint.check, {
    answers,
  });
  

      setResults(res.data.results);

      message.success(
        `Score: ${res.data.score}/${res.data.total}`
      );

      addPointsToBackend(res.data.score);

      const explanations = {};

      setLoadingExplanation(true);

      for (const item of answers) {
        const correct =
          res.data.correctAnswers?.[item.id];

        if (String(item.answer) !== String(correct)) {
          const questionText =
            questions.find((q) => q.id === item.id)
              ?.question || "";

          const explainRes = await api.post(
            "/quiz/explain2",
            {
              question: questionText,
              correctAnswer: correct,
              userAnswer: item.answer,
            }
          );

          explanations[item.id] =
            explainRes.data.explanation;
        }
      }

      setAiExplanations(explanations);
      setLoadingExplanation(false);
    } catch (err) {
      message.error("Failed to submit quiz");
    }
  };

  // -----------------------------
  // New Game
  // -----------------------------

  const startNewGame = async () => {
    await fetchQuestions();
  };

  // -----------------------------
  // Loading
  // -----------------------------

  if (loading) {
    return (
      <Title
        level={3}
        style={{
          textAlign: "center",
          marginTop: 80,
        }}
      >
        Loading Quiz...
      </Title>
    );
  }

  // ---------- PART 2 CONTINUES ----------
    // ===========================
  // RESULTS SCREEN
  // ===========================

  if (finished && results.length) {
    return (
      <div
        style={{
          width: "100%",
          maxWidth: 700,
          margin: "auto",
          borderRadius: 20,
          background:
            "linear-gradient(135deg,#a9b1f3,#8a1043)",
          padding: 20,
          boxShadow: "0 8px 20px rgba(0,0,0,.25)",
        }}
      >
        <Title
          level={3}
          style={{
            textAlign: "center",
            color: "#fff",
          }}
        >
          🎉 Quiz Results
        </Title>

        {results.map((r, i) => (
          <Card
            key={r.id}
            style={{
              marginBottom: 18,
              borderRadius: 16,
              padding: 18,
              background: r.isCorrect
                ? "#f6ffed"
                : "#fff1f0",
              border: r.isCorrect
                ? "3px solid #95de64"
                : "3px solid #ff7875",
              boxShadow:
                "0 6px 14px rgba(0,0,0,.08)",
            }}
          >
            <div
              style={{
                fontSize: 20,
                fontWeight: "bold",
                color: r.isCorrect
                  ? "#389e0d"
                  : "#cf1322",
                marginBottom: 12,
              }}
            >
              Question {i + 1}
            </div>

            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                marginBottom: 14,
              }}
            >
              {questions[i].question}
            </div>

            <div
              style={{
                fontSize: 17,
                marginBottom: 10,
              }}
            >
              <strong>Your Answer : </strong>

              <span
                style={{
                  color: r.isCorrect
                    ? "#389e0d"
                    : "#cf1322",
                  fontWeight: "bold",
                }}
              >
                {formatUnits(r.userAnswer)}
              </span>
            </div>

            {!r.isCorrect && (
              <div
                style={{
                  fontSize: 17,
                  color: "#237804",
                  fontWeight: "bold",
                  marginBottom: 12,
                }}
              >
                Correct Answer :{" "}
                {formatUnits(r.correctAnswer)}
              </div>
            )}

            {!r.isCorrect &&
              aiExplanations[r.id] && (
                <Card
                  size="small"
                  style={{
                    marginTop: 10,
                    background: "#fffbe6",
                    border:
                      "1px solid #ffe58f",
                  }}
                >
                  <strong>
                    🤖 AI Explanation
                  </strong>

                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      fontFamily: "inherit",
                      marginTop: 10,
                    }}
                  >
                    {aiExplanations[r.id]}
                  </pre>
                </Card>
              )}
          </Card>
        ))}

        {loadingExplanation && (
          <Title
            level={5}
            style={{
              textAlign: "center",
              color: "#fff",
            }}
          >
            Generating AI explanations...
          </Title>
        )}

        {submitted && (
          <Button
            block
            onClick={startNewGame}
            style={{
              marginTop: 20,
              height: 50,
              fontSize: 18,
              fontWeight: "bold",
              borderRadius: 14,
              background: "orange",
              border: "none",
            }}
          >
            🔄 New Game
          </Button>
        )}
      </div>
    );
  }

  const submitAnswer = () => {
  if (!answer.trim()) {
    message.warning("Please enter an answer.");
    return;
  }

  const updatedAnswers = [
    ...userAnswers,
    {
      id: questions[index].id,
      answer: answer.trim(),
    },
  ];

  setUserAnswers(updatedAnswers);
  setAnswer("");

  if (index === questions.length - 1) {
       setSubmitting(true); 
    setFinished(true);
    finishQuiz(updatedAnswers); // pass the latest answers
  } else {
    setIndex(index + 1);
  }
}

 return (
     <div 
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    textAlign: "center",
    padding: "10px",
    gap: "10px",
  }}

    >
    <div>
 


    <Card
       style={{
    maxWidth: 650,
    borderRadius: 20,
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
   
//     background: "linear-gradient(135deg, #30a5eeff, #0bafbbff)",
 background: "linear-gradient(135deg, #87e8de, #ffadd2)",
 boxShadow: "0 8px 20px rgba(255, 150, 180, 0.35)",

    border: "5px solid #ffd666"
  }}
    ><h2 style={{textAlign:"center"}}>🧠    
  {topics === "conversion"
    ? "📏 Measurement Conversion"
    : topics === "addsub"
    ? "➕ Measurement Addition & Subtraction"
    : "📝 Measurement Word Problems"}
 🎉</h2><hr></hr><br></br>
      <Title level={4}>
        Question {index + 1} 
       
      </Title>

      <p style={{ fontSize: 20, marginBottom: 20 ,fontWeight:"bold",color:"red"}}>{questions[index]?.question}</p>

      <Input
        ref={inputRef}
        value={answer}
        placeholder="Enter like 7.55 m or 7m55cm "
        onChange={e => setAnswer(e.target.value)}
        onPressEnter={submitAnswer}
        autoComplete="off"
        //style={{ fontSize: 16, padding: 12 }}
        style={{
    fontSize: 18,
    padding: 14,
    borderRadius: 12,
    border: "2px solid #91caff"
  }}
      />

      {/* <Button
        type="primary"
        block
       // style={{ marginTop: 20, padding: "12px 0", fontSize: 16 }}
        style={{
    marginTop: 20,
    height: 50,
    fontSize: 18,
    fontWeight: "bold",
    borderRadius: 14,
    background: "linear-gradient(90deg, #52c41a, #a0d911)",
    border: "none"
  }}
        onClick={submitAnswer}
      >
        Submit
      </Button> */}
      <Button
  type="primary"
  block
  disabled={submitting}
  loading={submitting}
  onClick={submitAnswer}
  style={{
    marginTop: 20,
    height: 50,
    fontSize: 18,
    fontWeight: "bold",
    borderRadius: 14,
    background: "linear-gradient(90deg, #52c41a, #a0d911)",
    border: "none",
  }}
>
  Submit
</Button>
    
    </Card>
    </div>
    </div>
  
  );

}